import { settingsRoutes } from '@/routes/org-routes.const'

export type OrgSettingsViewType =
  | 'general'
  | 'members'
  | 'balance'
  | 'subscription'
  | 'invoices'
  | 'usage-audit'
  | 'payment-methods'
  | 'connectors'

export const ORG_SETTINGS_VIEW_TO_URL_PATH: Record<OrgSettingsViewType, string> = {
  general: settingsRoutes.general,
  members: settingsRoutes.members,
  balance: settingsRoutes.balance,
  subscription: settingsRoutes.subscription,
  invoices: settingsRoutes.invoices,
  'usage-audit': settingsRoutes.usageAudit,
  'payment-methods': settingsRoutes.paymentMethods,
  connectors: settingsRoutes.connectors,
}

export const ORG_SETTINGS_URL_PATH_TO_VIEW: Record<string, OrgSettingsViewType> = {
  [settingsRoutes.general]: 'general',
  [settingsRoutes.members]: 'members',
  [settingsRoutes.balance]: 'balance',
  [settingsRoutes.subscription]: 'subscription',
  [settingsRoutes.invoices]: 'invoices',
  [settingsRoutes.usageAudit]: 'usage-audit',
  [settingsRoutes.paymentMethods]: 'payment-methods',
  [settingsRoutes.connectors]: 'connectors',
}

export const ORG_SETTINGS_DEFAULT_VIEW: OrgSettingsViewType = 'general'

export const ORG_SETTINGS_VIEW_TITLES: Record<OrgSettingsViewType, string> = {
  general: 'General',
  members: 'Members',
  balance: 'Balance',
  subscription: 'Subscription',
  invoices: 'Invoices',
  'usage-audit': 'Usage Audit',
  'payment-methods': 'Payment Methods',
  connectors: 'Connectors',
}

export const ORG_SETTINGS_VIEW_DESCRIPTIONS: Record<OrgSettingsViewType, string> = {
  general: 'Manage your organization settings and preferences.',
  members: 'Manage team members and their roles.',
  balance: 'View and manage your account balance.',
  subscription: 'Manage your subscription plan.',
  invoices: 'View and download your invoices.',
  'usage-audit': 'Monitor usage and audit logs.',
  'payment-methods': 'Manage your payment methods.',
  connectors: 'Connect external services like Google Search Console and Analytics.',
}
